<div class="laudo-container" *ngIf="steps.length>0">


  <div class="m-lg-4 my-3" *ngIf="steps.length>0">
    <app-step-by-step [index]="stepIndex" (indexChange)="stepChange($event)" [steps]="steps" [touchedIndex]="stepTouched"></app-step-by-step>
  </div>



  <div class="d-flex flex-grow-1">

    <div class="m-lg-2 w-100">
      <ng-container *ngIf="step">
        <app-form-img-laudo [template]="template" [elements]="elements" *ngIf="step?.templateComponent=='fotos'"></app-form-img-laudo>
        <app-form-hg-laudo (formHgValidoEmit)="formHgValidoEmit($event)" *ngIf="step?.templateComponent=='hg'" [placa]="placa" [tokenLaudo]="token"></app-form-hg-laudo>
        <app-template-builder *ngIf="!step?.templateComponent" [children]="template" [elements]="elements"></app-template-builder>
      </ng-container>
    </div>

    <app-side-preview [form]="formLaudo" [laudo]="laudo" [elements]="elements"></app-side-preview>

  </div>

  <div class="d-flex flex-wrap flex-sm-nowrap p-1 p-lg-2 bg-white border-top border-gray-300">
    <div class="col p-1 p-lg-2">
      <button [disabled]="stepIndex==0" (click)="backStep()" class="btn btn-lg btn-primary btn-icon w-100">
        <i class="mdi mdi-arrow-left"></i>
        <span class="w-100">Voltar</span>
      </button>
    </div>
    <div class="col-sm p-1 p-lg-2 order-last order-sm-0">
      <button *ngIf="!laudo.consultaRealizada" (click)="realizarConsulta(modalConsultaLaudo)" class="btn btn-lg btn-info btn-icon w-100">
        <span class="w-100">Realizar consulta</span>
        <i class="mdi mdi-database-search"></i>
      </button>
      <a *ngIf="laudo.consultaRealizada" [routerLink]="['/consulta', 'resultado', laudo.tokenConsulta ]" rel="noopener noreferrer" target="_blank" class="btn btn-lg btn-info btn-icon w-100">
        <span class="w-100">Visualizar Consulta</span>
        <i class="mdi mdi-eye"></i>
      </a>
    </div>
    <div class="col p-1 p-lg-2">
      <button [disabled]="stepIndex >= (steps.length-1)" (click)="nextStep()" class="btn btn-lg btn-primary btn-icon w-100">
        <span class="w-100  bg-o-white">Próximo</span>
        <i class="mdi mdi-arrow-right"></i>
      </button>
    </div>
    <div class="col p-1 p-lg-2">
      <button (click)="showModalParecer(modalParecer)" class="btn btn-lg btn-primary btn-icon w-100">
        <span class="w-100">Parecer Técnico</span>
        <i class="mdi mdi-pencil-box"></i>
      </button>
    </div>
    <!--div class="col p-1 p-lg-2">
      <button (click)="nextStep()" class="btn btn-lg btn-success btn-icon w-100">
        <span class="w-100">Finalizar laudo</span>
        <i class="mdi mdi-check"></i>
      </button>
    </div -->
  </div>

</div>

<ng-template #modalParecer let-modal>
    <app-form-parecer-laudo [modal]="modal"></app-form-parecer-laudo>
</ng-template>

<ng-template #modalConsultaLaudo let-modal>
  <app-form-realizar-consulta-laudo
    [modal]="modal"
    [tokenLaudo]="token"
    [placa]="placa"
    >
  </app-form-realizar-consulta-laudo>
</ng-template>
